import * as Sentry from '@sentry/react'

// The Vite build leaves `{{SENTRY_DSN}}` as a placeholder in the bundle
// (so we can build once and inject the DSN at container start). When
// the placeholder is left unsubstituted (e.g. in `npm run dev` or if
// the operator forgot to set the env var), treat it as "no DSN" and
// turn the SDK into a no-op.
const RAW_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined
const DSN = RAW_DSN && !RAW_DSN.startsWith('{{') ? RAW_DSN : undefined

export function initSentry(): void {
  if (!DSN) return

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    release: (import.meta.env.VITE_GIT_SHA as string | undefined) || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    beforeBreadcrumb(breadcrumb) {
      // Strip query strings from fetch/xhr breadcrumbs so we don't ship
      // invite tokens, accept-invite ids, etc. into Sentry.
      if ((breadcrumb.category === 'fetch' || breadcrumb.category === 'xhr') && breadcrumb.data?.url) {
        const url = breadcrumb.data.url as string
        const qIndex = url.indexOf('?')
        if (qIndex >= 0) {
          breadcrumb.data.url = url.slice(0, qIndex)
        }
      }
      return breadcrumb
    },
  })
}
